import React, { useEffect, useRef, createElement } from 'react';
declare global {
  interface Window {
    fbq?: any;
    _fbq?: any;
  }
}
export function FacebookPixel() {
  const initialized = useRef(false);
  useEffect(() => {
    // Prevent double initialization
    if (initialized.current || window.fbq) {
      return;
    }
    initialized.current = true;
    (function (f: any, b: Document, e: string, v: string) {
      if (f.fbq) return;
      const n: any = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
      const t = b.createElement(e) as HTMLScriptElement;
      t.async = true;
      t.src = v;
      const s = b.getElementsByTagName(e)[0];
      s.parentNode!.insertBefore(t, s);
    })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    // Initialize pixel - PageView is tracked automatically by Facebook Pixel
    // DO NOT manually call fbq('track', 'PageView') as it causes duplicate events
    const initPixel = () => {
      if (window.fbq) {
        window.fbq('init', '1168982065360083');
        // PageView is automatically tracked by the pixel after init
      }
    };
    setTimeout(initPixel, 100);
    // Add noscript fallback
    const noscript = document.createElement('noscript');
    const img = document.createElement('img');
    img.height = 1;
    img.width = 1;
    img.style.display = 'none';
    img.src = 'https://www.facebook.com/tr?id=1168982065360083&ev=PageView&noscript=1';
    noscript.appendChild(img);
    if (document.body.firstChild) {
      document.body.insertBefore(noscript, document.body.firstChild);
    } else {
      document.body.appendChild(noscript);
    }
  }, []);
  return null;
}